<template>
  <div
    v-if="show"
    id="process-overlay"
    :class="[overlayClass || '']"
  >
    <img
      src="@shared/assets/img/general/loading-white.svg"
      class="process"
      alt="Processing"
    >
    <span>
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'ProcessOverlay',
  props: {
    show: Boolean,
    text: String,
    overlayClass: String,
  },
};
</script>

<style lang="scss">

#process-overlay {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: rgba(73, 121, 255, 0.7);
  color: $WHITE;
  font-size: 1rem;
  font-weight: 500;
  z-index: 10;
}
</style>
